import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { Controller } from 'react-hook-form'
import { FormControl } from '@mui/material'
import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers_modern/DateTimePicker'
import { AdapterDayjs } from '@mui/x-date-pickers_modern/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers_modern/LocalizationProvider'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import { LOCALE_MAP } from 'utils/constants'

dayjs.extend(utc)
dayjs.extend(timezone)

const DateTimePicker = ({ name, label, control, variant, defaultDateTime, dateTimePickerProps, ...restProps }) => {
  const labelId = `${name}-label`
  const { locale: yardLocale } = useAppSelector(state => state.auth)

  return (
    <FormControl sx={{ width: '100%' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={LOCALE_MAP[yardLocale]?.dayjs || 'en'}>
        <Controller
          render={({ field: { onChange, value } }) => {
            if (value instanceof Date && value) {
              value = dayjs(value)
            }

            return (
              <MuiDateTimePicker
                labelId={labelId}
                label={label}
                value={value}
                onChange={onChange}
                timeSteps={{ minutes: 1 }}
                {...dateTimePickerProps}
                slotProps={{
                  textField: {
                    variant,
                    ...restProps,
                  },
                }}
              />
            )
          }}
          name={name}
          control={control}
          defaultValue={defaultDateTime}
        />
      </LocalizationProvider>
    </FormControl>
  )
}

DateTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  defaultDateTime: PropTypes.object,
  control: PropTypes.instanceOf(Object).isRequired,
  dateTimePickerProps: PropTypes.object,
}

DateTimePicker.defaultProps = {
  variant: 'standard',
  defaultDateTime: null,
  dateTimePickerProps: {},
}

export default DateTimePicker
